module.exports = __webpack_public_path__ + "img/gb825.prt.5669eee9.jpg";